﻿export default function () {


	let preselectedFacets = [];

	const selectors = {
		pagination: '#search-pagination',
		facets: '#search-facets',
		results: '#search-results',
		filterBar: '#search-filterbar'
	};

	const containers = Object.fromEntries(
		Object.entries(selectors).map(([key, sel]) => [key, document.querySelector(sel)])
	);

	function EnsureAllElementsExist() {
		return Object.values(containers).every(Boolean);
	}

	let currentPage = '1';
	function loadSearch(query, selectedFacets = [], page, layout, orderBy) {
		const url = new URL(window.location.origin + '/umbraco/surface/FacetedSearchSurface/Search');

		url.searchParams.set('layout', layout);
		url.searchParams.set('query', query);
		url.searchParams.set('page', page);
		url.searchParams.set('orderBy', orderBy);
		selectedFacets.forEach(f => url.searchParams.append('facets', f));

		fetch(url)
			.then(res => res.text())
			.then(html => {


				const tempDiv = document.createElement('div');
				tempDiv.innerHTML = html;


				for (const [key, selector] of Object.entries(selectors)) {
					const newContent = tempDiv.querySelector(selector);
					if (newContent && containers[key]) {
						containers[key].innerHTML = newContent.innerHTML;
					}
				}

				document.querySelector('#filter-button').classList.remove("collapsed");
				document.querySelector('#searchbarfilters').classList.remove("collapsed");
				document.querySelector('#searchbarfilters').classList.add("collapse", "show");

				if (page !== currentPage) {
					currentPage = page;
					window.scrollTo(0, 0);

				}

				preselectedFacets.forEach(facet => {
					const facetKey = facet.split(':')[0];
					const safeKey = CSS.escape(facetKey.trim());

					// Hide sidebar facet
					const sidebarFacet = document.getElementById(`filterwrapper_${safeKey}`);
					if (sidebarFacet) sidebarFacet.style.display = 'none';

					// Hide filter bar facet
					const barFacet = document.getElementById(`filterinbarwrapper_${safeKey}`);
					if (barFacet) barFacet.style.display = 'none';
				});

				var event = new CustomEvent("searchResultsUpdated");
				document.dispatchEvent(event);

				// Reopen previously opened dropdown
				/*
				const openId = localStorage.getItem('openDropdown');
				if (openId) {
					document.querySelector('#search-filterbar').style.display = "none";
					document.querySelector(`.facet-dropdown[data-facet-group="${openId}"] .facet-dropdown-expander`).click();

					//document.querySelector(`.facet-dropdown .dropdown-menu`).classList.remove("show");
					//document.querySelector(`.facet-dropdown .facet-dropdown-expander`).classList.remove("show");

					//document.querySelector(`.facet-dropdown[data-facet-group="${openId}"] .dropdown-menu`).classList.add("show");
					//document.querySelector(`.facet-dropdown[data-facet-group="${openId}"] .facet-dropdown-expander`).classList.add("show");

					document.querySelector('#filter-button').classList.remove("collapsed");
					document.querySelector('#searchbarfilters').classList.remove("collapsed");
					document.querySelector('#searchbarfilters').classList.add("collapse", "show");

				
					document.querySelector('#search-filterbar').style.display = "block";
				}
				*/
			});
	}


	document.addEventListener('DOMContentLoaded', () => {

		if (EnsureAllElementsExist()) {

			const urlParams = new URLSearchParams(window.location.search);
			const query = urlParams.get('query') || '';
			let page = urlParams.get('page') || '1';
			let selectedFacets = urlParams.getAll('facets');
			let layout = urlParams.get('layout') || '1';
			let orderBy = urlParams.get('orderBy') || '';

			// Read pre-selected facets from data attribute
			let preselectedFacetsFromViewRaw = document.querySelector(selectors.results).dataset.preselectedFacets;

			if (preselectedFacetsFromViewRaw && preselectedFacetsFromViewRaw.length !== 0) {
				try {
					if (selectedFacets.length === 0) {
						selectedFacets = JSON.parse(preselectedFacetsFromViewRaw);
					}
					preselectedFacets = JSON.parse(preselectedFacetsFromViewRaw);
				} catch (e) {
					console.warn("Failed to parse pre-selected facets:", e);
				}
			}


			// Initial load
			loadSearch(query, selectedFacets, page, layout, orderBy);

			// Get unique selected facets
			function getSelectedFacets() {
				return Array.from(document.querySelectorAll('.facet-checkbox:checked'))
					.map(cb => cb.value)
					.filter((v, i, a) => a.indexOf(v) === i); // unique values
			}

			// Store in url 
			function PushHistoryState(query, selected, page, layout, orderBy) {
				history.pushState(
					{ query, selected },
					'',
					`${window.location.pathname}?layout=${layout}&page=${page}&query=${query}&orderBy=${orderBy}` + selected.map(f => `&facets=${encodeURIComponent(f)}`).join('')
				);
			}

			// Sync all checkboxes with the same value
			function syncCheckboxes(value, checked) {
				document.querySelectorAll(`.facet-checkbox[value="${CSS.escape(value)}"]`).forEach(cb => {
					cb.checked = checked;
				});
			}

			// Handle facet checkbox changes
			document.addEventListener('change', e => {
				if (!e.target.matches('.facet-checkbox')) return;

				const value = e.target.value;
				const checked = e.target.checked;

				// Sync duplicate checkboxes
				syncCheckboxes(value, checked);

				// Trigger search
				const selected = getSelectedFacets();
				loadSearch(query, selected, 1, layout, orderBy);
				PushHistoryState(query, selected, 1, layout, orderBy);


				// Remember open dropdown
				const ancestorDropdown = e.target.closest('.facet-dropdown');
				if (ancestorDropdown) {
					const dropdownId = ancestorDropdown.getAttribute('data-facet-group');
					localStorage.setItem('openDropdown', dropdownId);
				}
			});

			// Facet headings toggle
			document.querySelector(selectors.facets).addEventListener('click', e => {
				if (e.target.matches('.filter_type_heading')) {
					$(e.target).toggleClass('opened');
					$(e.target).toggleClass('closed');
				}
			});

			//Layout change toggle
			document.querySelector(selectors.filterBar).addEventListener('click', e => {
				const target = e.target.closest('[data-resultlayout]');
				if (target) {
					layout = target.getAttribute('data-resultlayout');
					const selected = getSelectedFacets();
					loadSearch(query, selected, page, layout, orderBy);
					PushHistoryState(query, selected, page, layout, orderBy);
				}
			});

			// Handle pagination clicks
			document.querySelector(selectors.pagination).addEventListener('click', e => {
				if (e.target.matches('.page-link')) {
					e.preventDefault();
					page = parseInt(e.target.dataset.page);
					const selected = getSelectedFacets();
					loadSearch(query, selected, page, layout, orderBy);
					PushHistoryState(query, selected, page, layout, orderBy);
				}
			});

			// Ensure duplicates are synced on initial load
			document.querySelectorAll('.facet-checkbox:checked').forEach(cb => {
				syncCheckboxes(cb.value, true);
			});

			document.addEventListener('searchResultsUpdated', e => {
				const sort = document.getElementById('sort');
				if (sort) {
					sort.addEventListener('change', e => {
						orderBy = e.target.value;
						const selected = getSelectedFacets();
						loadSearch(query, selected, page, layout, orderBy);
						PushHistoryState(query, selected, page, layout, orderBy);
					});
				}
			});
		}
	});

}    